import { render, staticRenderFns } from "./scratchCardModel.vue?vue&type=template&id=6ea0fd49&scoped=true&"
import script from "./scratchCardModel.vue?vue&type=script&lang=js&"
export * from "./scratchCardModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea0fd49",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/yx-web-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ea0fd49')) {
      api.createRecord('6ea0fd49', component.options)
    } else {
      api.reload('6ea0fd49', component.options)
    }
    module.hot.accept("./scratchCardModel.vue?vue&type=template&id=6ea0fd49&scoped=true&", function () {
      api.rerender('6ea0fd49', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Activity/Children/SettingChildred/scratchCardModel.vue"
export default component.exports